module.exports = "/_next/static/images/rolex_model_background_gold_portrait-047787839ab07788ff10d6b0467b6c68.jpg";